import React from 'react';

import { I18n } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import Settings from 'configs/Settings';
import CtaCommunities from 'modules/content/components/ctaCommunities/ctaCommunities';
import AppVersion from 'modules/user/components/AppVersion';
import Login from 'modules/user/components/Login';

import BroadcastManagerIndex from '../broadcastManager/BroadcastManagerIndex';
import ClassManagerIndex from '../classManager/ClassManagerIndex';
import CommunityManagerIndex from '../community/CommunityManagerIndex';
import ConfigManagerIndex from '../configManager/ConfigManagerIndex';
import ContentIndex from '../content/components/contentIndex';
import DashboardIndex from '../dashboard/components/DashboardIndex';
import MembershipReportsIndex from '../membershipReports/MembershipReportsIndex';
import SalesManagerIndex from '../salesManager/SalesManagerIndex';
import UserManagerIndex from '../userManager/UserManagerIndex';

const TEMPORARY_LOGIN_ROUTE = {
  private: false,
  exact: true,
  path: ROUTES.LOGIN,
  title: 'Login',
  layout: 'external',
  component: Login
};

const COMMUNITY_ROUTE = {
  name: 'community',
  private: true,
  path: ROUTES.COMMUNITY.LIST,
  title: <I18n label="general.comments" />,
  layout: 'logged',
  component: CommunityManagerIndex
};

export const COMMON_ROUTES = [
  {
    private: false,
    exact: true,
    path: ROUTES.HEALTH_CHECK,
    title: 'Hotmart Club',
    layout: 'external',
    component: AppVersion
  }
];

export const PUBLIC_ROUTES = (() => {
  return Settings.isLocal ? [TEMPORARY_LOGIN_ROUTE] : [];
})();

export const PRIVATE_ROUTES = [
  {
    name: 'content',
    private: true,
    path: `(${ROUTES.CONTENT.LIST}|${ROUTES.CONTENT.TRACKS})`,
    title: 'Conteudos',
    layout: 'logged',
    component: ContentIndex
  },
  {
    name: 'ctaCommunities',
    private: true,
    path: ROUTES.CTA_COMMUNITIES,
    title: <I18n label="general.communities" />,
    layout: 'logged',
    component: CtaCommunities
  },
  {
    name: 'userManager',
    private: true,
    path: ROUTES.USER.LIST,
    title: <I18n label="general.users" />,
    layout: 'logged',
    component: UserManagerIndex
  },
  {
    name: 'broadcast',
    private: true,
    path: ROUTES.BROADCAST.LIST,
    title: <I18n label="general.broadcast" />,
    layout: 'logged',
    component: BroadcastManagerIndex
  },
  {
    name: 'classList',
    private: true,
    path: ROUTES.CLASS.LIST,
    title: <I18n label="class_manager.title" />,
    layout: 'logged',
    component: ClassManagerIndex
  },
  {
    name: 'salesManager',
    private: true,
    path: `(${ROUTES.SALES}|${ROUTES.FREE_SIGNUP})`,
    title: <I18n label="sales_manager.title" />,
    layout: 'logged',
    component: SalesManagerIndex
  },
  {
    name: 'configManager',
    private: true,
    path: ROUTES.CONFIG,
    title: <I18n label="config_manager.title" />,
    layout: 'logged',
    component: ConfigManagerIndex
  },
  {
    name: 'reports',
    private: true,
    path: ROUTES.REPORTS,
    title: <I18n label="config_manager.title" />,
    layout: 'logged',
    component: MembershipReportsIndex
  },
  {
    name: 'dashboard',
    private: true,
    path: ROUTES.DASHBOARD,
    title: <I18n label="general.dashboard" />,
    layout: 'logged',
    component: DashboardIndex
  },
  COMMUNITY_ROUTE
];

export const MODERATOR_ROUTES = [
  ...PUBLIC_ROUTES,
  ...COMMON_ROUTES,
  COMMUNITY_ROUTE
];

const Routes = [...PUBLIC_ROUTES, ...COMMON_ROUTES, ...PRIVATE_ROUTES];

export default Routes;
